import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { ProductPricesModel } from '@libs/shop/models';
import { ProductPriceVisibilityDirective } from '@libs/shared/ui';
import { ProductPricesComponent } from '../../catalog';
import { ProductPriceFormatterComponent } from '../../catalog/product-prices/product-price-formatter';
import { ProductPricesDefaultComponent } from '../../catalog/product-prices/product-prices-default';

@Component({
  selector: 'ui-product-detail-prices',
  templateUrl: './product-detail-prices.component.html',
  styleUrl: './product-detail-prices.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProductPricesComponent,
    ProductPricesDefaultComponent,
    ProductPriceFormatterComponent,
    ProductPriceVisibilityDirective,
  ],
})
export class ProductDetailPricesComponent {
  public prices: InputSignal<ProductPricesModel> = input.required();
  public depositPrice: Signal<number> = computed(() => this.prices().salesUnitDeposit ?? 0);
}
